function navigation() {
  var dropdownMenuLink = document.querySelectorAll('li.menu-item--expanded');
  var navbarToggler = document.querySelectorAll('.nasvbar-expand-lg .navbar-collapse .navbar-toggler');
  var menuCloseButton = document.getElementById('menu-close-icon');
  var globalNav = document.getElementById('rayaldee-global-main-navigation');
  var localNav = document.getElementById('rayaldee-main-navigation');

  var nav = globalNav || localNav;

  // When open the menu on mobile/tablet set dark overlay to body
  if (navbarToggler && nav) {
    var observer = new MutationObserver(function (event) {
      if (event[0].target.classList.contains('show')) {
        document.getElementsByTagName('body')[0].classList.add('navbar-open')
      } else {
        document.getElementsByTagName('body')[0].classList.remove('navbar-open')
      }
    });

    observer.observe(nav, {
      attributes: true,
      attributeFilter: ['class'],
    })
  }

  if (menuCloseButton) {
    menuCloseButton.onclick = function() {
      document.querySelector('a.dropdown-toggle').classList.remove('show');
    };
  }

  if (dropdownMenuLink && window.innerWidth > 991) {
    Array.prototype.forEach.call(dropdownMenuLink, function(dropdownMenuLink) {
      dropdownMenuLink.onmouseover = function() {
        this.children[0].classList.add('show');
      };

      dropdownMenuLink.onmouseleave = function() {
        this.children[0].classList.remove('show');
      };
    });
  }

  // Add home page's path to the Global menu links (with earth icon)
  var global_menu_links = document.querySelectorAll(
      '.menu--global .menu-item a');

  if (global_menu_links) {
    Array.prototype.forEach.call(global_menu_links, function(menu_link) {
      menu_link.href = '/';
    });
  }
}
